// 导入自己需要的组件
import { Form, FormItem, Input, Button, Checkbox } from "element-ui";
const element = {
  install: function (Vue) {
    Vue.use(Form);
    Vue.use(FormItem);
    Vue.use(Input);
    Vue.use(Button);
    Vue.use(Checkbox);
  },
};
export default element;



// WEBPACK FOOTER //
// ./src/common/utils/element.js